module.exports = __webpack_public_path__ + "img/img8.193bb9f5.png";